<template>
    <div class="card card-form">
        <!-- Toolbar -->
        <div class="card-header">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <div class="btn-toolbar ml-auto">
                        <button class="btn btn-primary px-2 mr-1 d-lg-none" @click="filter.visible = !filter.visible">
                            <i class="fas fa-fw fa-filter" v-if="!filter.visible"></i>
                            <i class="fas fa-fw fa-times" v-if="filter.visible"></i>
                        </button>
                        <button class="btn btn-primary" @click="filterData()">
                            {{ $t('[[[Filtruj]]]') }}
                        </button>
                        <button class="btn btn-secondary" @click="resetFilter()">
                            {{ $t('[[[Resetuj]]]') }}
                        </button>
                    </div>
                </div>
            </responsive>
        </div>
        <div class="row no-gutters">
            <!-- Filtry -->
            <div class="col-lg-3 order-lg-last p-3 bg-light" :class="{'d-none d-lg-block': !filter.visible}">
                <b-form-group :label="$t('[[[Nazwa użytkownika]]]')" :invalid-feedback="filter.$errors.first('userName')" :state="filter.$errors.state('userName')">
                    <b-form-input v-model="filter.userName" type="text" name="userName"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Data od]]]')" :invalid-feedback="filter.$errors.first('dateFromUtc')" :state="filter.$errors.state('dateFromUtc')">
                    <datetimepicker v-model="filter.dateFromUtc" type="datetime" />
                </b-form-group>
                <b-form-group :label="$t('[[[Data do]]]')" :invalid-feedback="filter.$errors.first('dateDueUtc')" :state="filter.$errors.state('dateDueUtc')">
                    <datetimepicker v-model="filter.dateDueUtc" type="datetime" />
                </b-form-group>
                <div class="row">
                    <!-- <div class="col-9">
                        <b-form-group :label="$t('[[[Źródło]]]')" :invalid-feedback="filter.$errors.first('objectType')" :state="filter.$errors.state('objectType')">
                            <b-form-select name="objectType" v-model="filter.objectType" :options="typesOptions">
                            </b-form-select>
                        </b-form-group>
                    </div> -->
                    <!-- <div class="col-3">
                        <b-form-group :label="$t('[[[Id]]]')" :invalid-feedback="filter.$errors.first('objectId')" :state="filter.$errors.state('objectId')">
                            <b-form-input v-model="filter.objectId" type="number" name="objectId" min="0" @input="filter.objectId = Number($event)" :disabled="!filter.objectType"></b-form-input>
                        </b-form-group>
                    </div> -->
                </div>
                <b-form-group :label="$t('[[[Zdarzenie]]]')" :invalid-feedback="filter.$errors.first('operationType')" :state="filter.$errors.state('operationType')">
                    <b-form-select name="operationType" v-model="filter.operationType" :options="operationOptions">
                        <!-- <template slot="first">
                            <option :value="null"></option>
                        </template> -->
                    </b-form-select>
                </b-form-group>
            </div>
            <!-- Tabela -->
            <div class="col-lg-9 p-3">
                <responsive>
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th><sort :pager="pager" @change="onSorting" header="Id">{{ $t('[[[Autor zmian]]]') }}</sort></th>
                                <th><sort :pager="pager" @change="onSorting" header="OperationType">{{ $t('[[[Typ zmiany]]]') }}</sort></th>
                                <th><sort :pager="pager" @change="onSorting" header="OperationDateUtc">{{ $t('[[[Data zdarzenia]]]') }}</sort></th>
                                <th>{{ $t('[[[Co zmieniono]]]') }}</th>
                                <th>{{ $t('[[[Wartość obecna]]]') }}</th>
                                <th>{{ $t('[[[Wartość poprzednia]]]') }}</th>
                            </tr>
                        </thead>
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                <div class="mb-1">
                                    <b-link :to="{name:'core-users-edit', params: { id: author(item).id }}" :disabled="!item.author">
                                        {{ author(item).userName || 'n/a' }}
                                    </b-link>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <b>{{ operationTypeTranslator.translate(item.operationType) }}</b>
                                </div>
                                <div>
                                    {{ $t('[[[Typ obiektu: ]]]') + item.objectType }}
                                </div>
                            </td>
                            <td>
                                {{ item.operationDateUtc | datetime }}
                            </td>
                            <td>
                                <div v-for="change in item.changes" :key="change.key">
                                    {{ change.key }}
                                </div>
                            </td>
                            <td>
                                <div v-for="change in item.changes" :key="change.key">
                                    {{ change.current }}
                                </div>
                            </td>
                            <td>
                                <div v-for="change in item.changes" :key="change.key">
                                    {{ change.original }}
                                </div>
                            </td>
                        </tr>
                    </table>
                </responsive>
            </div>
        </div>
        <div class="card-footer">
            <responsive>
                <div class="d-flex flex-nowrap mt-auto">
                    <pagination :pager="pager" @change="filterData()" class="mx-auto"></pagination>
                    <select v-model="pager.pageSize" @change="filterData()" class="form-control w-auto ml-3">
                        <option v-for="item in [10, 20, 50, 100]" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
            </responsive>
        </div>
    </div>
</template>

<script lang="js">
import LogsService from '@/services/core/LogsService';
import { OperationTypeOptions, OperationTypeTranslator } from '@/enums/ChangeLogEnums';

export default
{
    data: function()
    {
        return {
            mobile: false,
            phone: false,
            items: [],
            types: {}
        };
    },

    store: {
        filter: 'modules.core.changelogs.filter',
        pager: 'modules.core.changelogs.pager'
    },

    computed:
    {
        typesOptions()
        {
            return Object.keys(this.types).map(p =>
            {
                return { value: p, text: this.types[p] };
            });
        },
        operationOptions()
        {
            return OperationTypeOptions;
        },
        operationTypeTranslator()
        {
            return OperationTypeTranslator;
        }
    },

    created: function()
    {
        this.initForm();
        this.loadData();
    },

    methods:
    {
        async initForm()
        {
            try
            {
                this.types = (await LogsService.GetModelTypes()).data;
            }
            catch (ex)
            {
                if (ex.code === 0)
                    this.$alert.danger(this.$t('[[[Nie udało się pobrać listy typów modeli]]]'));
            }
        },

        async loadData()
        {
            this.items = [];

            try
            {
                let response = await LogsService.getChangeLog(this.filter, this.pager);
                this.pager.setTotalRows(response.totalRows);
                this.items = response.data.items;
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.filter.$errors.record(ex.data.errors);

                this.pager.setTotalRows(0);
                this.items = [];
                this.$log.debug(ex);
            }
        },

        async filterData()
        {
            await this.loadData();
        },

        async resetFilter()
        {
            this.filter.reset();
            await this.loadData();
        },

        async onSorting(sorting, order)
        {
            await this.loadData();
        },

        author(item)
        {
            return item.author || {};
        },

        typeDescription(type)
        {
            return this.types[type] ? this.types[type] : type;
        }
    }
};

// Typescript referencyjny z nowszego Edito Core
// @Component({})
// export default class ChangesList extends Vue
// {
//     @Prop() private sessionId: number;

//     private types: Record<string, string> = {};
//     private items: ChangesListItemModel[] = [];

//     private get resultOptions(): Option<boolean>[]
//     {
//         return [
//             { value: null, text: '[[[Wszystkie próby]]]' },
//             { value: true, text: '[[[Poprawne]]]' },
//             { value: false, text: '[[[Nieudane]]]' }
//         ];
//     }

//     private get sortingOptions(): Option[]
//     {
//         return [
//             { value: 'Id', text: '[[[Id zdarzenia]]]' },
//             { value: 'OperationDateUtc', text: '[[[Data zdarzenia]]]' }
//         ];
//     }

//     private get filter(): Form<ChangesFilterModel>
//     {
//         return this.$store.state.core.changelog.filter;
//     }

//     private get pager(): Pager
//     {
//         return this.$store.state.core.changelog.pager;
//     }

//     private get operationOptions(): Option[]
//     {
//         return EntityStateOptions;
//     }

//     private get typesOptions(): Option[]
//     {
//         return Object.keys(this.types).map(p =>
//         {
//             return { value: p, text: this.types[p] };
//         });
//     }

//     created()
//     {
//         this.initForm();
//         this.loadData();
//     }

//     async initForm()
//     {
//         this.filter.sessionId = Number(this.sessionId || 0);

//         try
//         {
//             this.types = await LogsService.GetModelTypes();
//         }
//         catch (ex)
//         {
//             this.handleException(ex, {
//                 0: (ex: any) => this.$alert.danger(this.$t('[[[Nie udało się pobrać listy typów modeli]]]'))
//             });
//         }
//     }

//     async loadData()
//     {
//         this.items = [];

//         try
//         {
//             let response = await LogsService.getChangeLog(this.filter.data(), this.pager);
//             this.pager.setTotalRows(response.totalRows);
//             this.items = response.items;
//         }
//         catch (ex)
//         {
//             this.handleException(ex, {
//                 400: (ex: any) => this.$alert.warning(ex.message),
//                 422: (ex: any) => this.filter.$errors.record(ex.data.errors)
//             });

//             this.pager.setTotalRows(0);
//             this.items = [];
//             this.$log.debug(ex);
//         }
//     }

//     async filterData()
//     {
//         await this.loadData();
//     }

//     async resetFilter()
//     {
//         this.filter.reset();
//         await this.loadData();
//     }

//     clearSession()
//     {
//         this.$router.push({name: 'core-changelog'});
//     }

//     @Watch('sessionId')
//     onSessionIdChanged()
//     {
//         this.filter.sessionId = Number(this.sessionId || 0);
//         this.loadData();
//     }

//     author(item: ChangesListItemModel): AuthorModel
//     {
//         return item.author || {} as AuthorModel;
//     }

//     session(item: ChangesListItemModel): SessionModel
//     {
//         return item.session || {} as SessionModel;
//     }

//     operationName(operationType: EntityState)
//     {
//         return EntityStateName(operationType);
//     }

//     typeDescription(type: string)
//     {
//         return this.types[type] ? this.types[type] : type;
//     }
// }
</script>
